const numericEnv = (name, fallback) => {
  const value = Number(process.env[name]);
  return Number.isFinite(value) ? value : fallback;
};

export const CARE_SCORE_THRESHOLDS = Object.freeze({
  goodMin: numericEnv("REACT_APP_CARE_SCORE_GOOD_MIN", 80),
  mediumMin: numericEnv("REACT_APP_CARE_SCORE_MEDIUM_MIN", 60),
});

export function careScoreBand(score) {
  const value = Number(score);
  if (!Number.isFinite(value)) return "neutral";
  if (value >= CARE_SCORE_THRESHOLDS.goodMin) return "good";
  if (value >= CARE_SCORE_THRESHOLDS.mediumMin) return "medium";
  return "poor";
}

export const CARE_SCORE_TONES = Object.freeze({
  good: { accent: "var(--pc-score-good)", soft: "var(--pc-score-good-soft)" },
  medium: { accent: "var(--pc-score-medium)", soft: "var(--pc-score-medium-soft)" },
  poor: { accent: "var(--pc-score-poor)", soft: "var(--pc-score-poor-soft)" },
  neutral: { accent: "var(--pc-muted)", soft: "transparent" },
});
